import { Divider } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import DashboardWidget from "../Widget/DashboardWidget";
import LearningHubWidgetCards from "./Cards/LearningHubWidgetCards";
import styles from "./LearningHubWidget.module.scss";

type Props = {
	className?: string;
};

const LearningHubWidget = ({ className }: Props) => {
	const { t } = useTranslation("dashboard", { keyPrefix: "learningHub" });

	return (
		<DashboardWidget className={clsx(styles.widget, className)} title={t("title")}>
			<Divider className={styles.divider} />
			<LearningHubWidgetCards />
		</DashboardWidget>
	);
};

export default observer(LearningHubWidget);
